module.exports = __webpack_public_path__ + "media/images/mypage/researcher/fan_clubs/open_requests/under_examination-182a88f024f6b4d63535985b26dab0ee.svg";